module.exports = __webpack_public_path__ + "components/resort-condition/static/conditions-off-piste-7c81a21c52fbc70606e101b991d47e4c.svg";